/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { MODES } from "cms/images/image-selector/image-selector-config";

const ImageDialogBottomActions = () => {
    
    const { t } = useTranslation();
    const imageEditContext = useContext(ImageEditContext);
    const handleClose = imageEditContext?.handleClose;
    const setOpenEdit = imageEditContext?.setOpenEdit;
    const selectedImage = imageEditContext?.selectedImage;
    const onSelectImage = imageEditContext?.onSelectImage;
    const onSaveImage = imageEditContext?.onSaveImage;
    const clearFiles = imageEditContext?.clearFiles;
    const mode = imageEditContext?.mode;
    const setMode = imageEditContext?.setMode;
    const setSelectedEditTab = imageEditContext?.setSelectedEditTab;
    const onUploadStart = imageEditContext?.onUploadStart;
    const filesReady = imageEditContext?.filesReady;

    const cancelDisabled = false;
    const saveDisabled = false;
    
    const handleUpload = () => {
        onUploadStart();
    };
    const handleCancel = () => {
        setMode(MODES.SELECT);
        clearFiles();
        handleClose();
    };
    const handleClear = () => {
        clearFiles();
    };
    
    // this is choosing the image
    const handleSelect = () => {
        // if (selectedImage.title && selectedImage.description && selectedImage.alt) {
        if (selectedImage.title && selectedImage.alt) {
            onSelectImage(selectedImage);
            
        } else {
            // alert('Need to edit required properties')
            setSelectedEditTab(0);
            setOpenEdit(true);
            // handleClose()
            onSelectImage(selectedImage);
        }
    };
    
    const handleSave = () => {
        // if (selectedImage.title && selectedImage.description && selectedImage.alt) {
        if (selectedImage.title && selectedImage.description) {
            onSaveImage(selectedImage);
        } else {
            //alert('Need to edit required properties')
            setSelectedEditTab(0);
            setOpenEdit(true);
            handleClose();
        }
    };
    
    return (
        <div className="simplicity-image-selector-window-footer">
            {mode === MODES.SELECT &&
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleSelect}
                >
                    {t("commons.select")}
                </Button>
            }
            
            {mode === MODES.SELECT_PREVIEW &&
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleSelect}
                >
                    {t("commons.select")}
                </Button>
            }
            
            {mode === MODES.EDIT &&
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleSave}
                    disabled={saveDisabled}
                >
                    {t("commons.save")}
                </Button>
            }
            
            {mode === MODES.UPLOAD &&
                <>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={handleUpload}
                        disabled={!filesReady}
                    >
                        {t("commons.upload")}
                    </Button>
                    <Button
                        variant='outlined'
                        color='secondary'
                        onClick={handleClear}
                    >
                        {t("commons.clear")}
                    </Button>
                </>
            }
            
            <Button
                variant='outlined'
                color='secondary'
                onClick={handleCancel}
                disabled={cancelDisabled}
            >
                {t("commons.cancel")}
            </Button>
        
        </div>
    );
};

export { ImageDialogBottomActions };
